import React from 'react';
import { Form } from '@ant-design/compatible';

import { Modal, Input, Button, Col } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

const EquipmentUnlinkForm = Form.create({ name: 'equipmentUnlinkForm_into_modal' })(

    class extends React.Component {
        render() {
            const {
                visible, onCancel, onUnlink, form, equipment
            } = this.props;
            const { getFieldDecorator } = form;
            return (
                <Modal
                    open={visible}
                    title={`Desenlazar equipo de entrada ${equipment.equipmentKey}`}
                    onCancel={onCancel}
                    footer={[
                        <Button className="back-button" key="back" onClick={onCancel}>Cancelar</Button>,
                        <Button className="submit-button" key="submit" onClick={onUnlink}>Desenlazar</Button>
                    ]}
                >
                    <p>{`¿Estás seguro que quieres desenlazar el equipo de entrada ${equipment.equipmentKey}?`}</p>
                    <Form layout='vertical' >
                        <Form.Item label="Id de la manguera" hidden>
                            {getFieldDecorator('equipmentKey', {
                                initialValue: equipment.equipmentKey,
                                rules: [{ required: true, message: 'Por favor introduce el id de la manguera' }]
                            })(
                                <Input disabled />
                            )}
                        </Form.Item>
                        <Col span={24}>
                            <Form.Item label="Motivo de desenlace">
                                {getFieldDecorator('unlinkReason', {
                                    rules: [{
                                        required: true, message: 'Por favor ingresa el motivo del desenlace.'
                                    }]
                                })(
                                    <TextArea autoSize={{ minRows: 2, maxRows: 6 }} maxLength={60} placeholder="Ingrese motivo del desenlace."/>
                                )}
                            </Form.Item>
                        </Col>
                    </Form>
                </Modal>
            );
        }
    }
);

export default EquipmentUnlinkForm;
